import { Helmet } from "react-helmet-async";

import { site } from "@/content/site";

export type SEOProps = {
  title: string;
  description?: string;
  /** When true, do not append the site name to the title. */
  exactTitle?: boolean;
  path?: string;
  image?: string;
};

export function SEO({
  title,
  description,
  exactTitle = false,
  path = "/",
  image,
}: SEOProps) {
  const fullTitle = exactTitle ? title : `${title} - ${site.name}`;
  const desc = description ?? site.description;
  const url = `${site.url.replace(/\/$/, "")}${path}`;
  const slug = path === "/" ? "home" : path.replace(/^\//, "");
  const resolvedImage = image || `/images/og/${slug}.png`;
  const imageUrl = `${site.url.replace(/\/$/, "")}${resolvedImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* OpenGraph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageUrl} />
      <meta
        property="og:image:alt"
        content="Distressed Membertou Boxing Club poster art reading Where Warriors Train."
      />
      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
}
